// top-level imports
import React from 'react';
import { withRouter } from 'react-router-dom';
// APOLLO
import { graphql, compose } from 'react-apollo';
import CREATE_ORGANIZATION from 'ApolloClient/Mutations/createOrganization';
// ANTD
import FormItem from 'components/common/FormItem';
import Button from 'components/common/Button';
import Row from 'antd/lib/row';
import TextInput from 'components/inputs/TextInput';
import TextAreaInput from 'components/inputs/TextAreaInput';
import message from 'antd/lib/message';
// COMPONENTS
import ImageUploadInput from 'components/inputs/ImageUploadInput';


class ClientForm extends React.Component {
  state = {
    loading: false,
    title: '',
    description: '',
  };

  onChange = newValue => {
    // uupdate local state with an object that is the field name and value, e.g { email: anthony@google.com } coming from the email input
    this.setState(newValue);
  };

  onCreate = variables => {

    this.props.createOrganization({ variables }).then(res => {
      this.setState({ loading: false });
      message.success('successfully added!', 3);
      window.location.reload();
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ loading: true });

    const { title, description } = this.state;

    // Validate fields
    if (!title || title.trim().length === 0) {
      message.error('Title is required!', 3);
      this.setState({ loading: false });
      return;
    }

    const variables = {
      params: { title, description },
    };
    if (this.state.image) {
      variables.params.image = this.state.image;
    }

    this.onCreate(variables);
  };

  render() {
    const { updateForm } = this.props;

    return (
      <div style={{ maxWidth: 400, margin: 'auto' }}>
        <form onSubmit={this.handleSubmit} style={{ width: '100%' }}>
          <Row>
            <ImageUploadInput
              cloudinaryOptions={{ croppingAspectRatio: 0.5, maxImageHeight: 150, maxImageWidth: 150 }}
              value={this.state.image}
              onChange={image => this.onChange({ image })}
            />
          </Row>

          <FormItem>
            <label>Studio Name</label>
            <TextInput
              value={this.state.title}
              placeholder="Studio Name..."
              onChange={(title) => { this.onChange({ title }); }}
            />
          </FormItem>

          <FormItem>
            <label>Enter a profile note (optional)</label>
            <TextAreaInput
              value={this.state.description}
              rows={5}
              onChange={e => {
                this.onChange({ description: e.target.value });
              }}
            />
          </FormItem>

          <Button
            style={{ marginLeft: 8 }}
            loading={this.state.loading}
            type="primary"
            htmlType="submit"
            size="large"
          >
            {!updateForm && !this.state.loading && 'Create Studio!'}
            {!updateForm && this.state.loading && 'Creating...'}
            {updateForm && !this.state.loading && 'Save'}
            {updateForm && this.state.loading && 'Saving...'}
          </Button>
        </form>
      </div>
    );
  }
}

export const FormWrapper = props => {
  if (props.updateForm && props.postData.loading) {
    return <div style={{ height: 380 }} />;
  }
  return <ClientForm {...props} />;
};

export default compose(
  graphql(CREATE_ORGANIZATION, { name: 'createOrganization' }),
)(withRouter(FormWrapper));



// WEBPACK FOOTER //
// ./src/components/forms/CreateStudioForm/index.js